module.exports = __webpack_public_path__ + "img/watage_res_9.50dd6f1e.gif";